module.exports = __webpack_public_path__ + "img/avatar.9f059fb4.gif";